export default "__VITE_ASSET__rPjZsq8h__"